import React, { useState, useEffect } from "react";
import GetIcon from "../../../../utils/Icon.jsx";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button.jsx";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo.jsx";
import ApiResponseBox from "../../../../Components/ApiResponseBox.jsx";
import { useGetPurchaseOrderListMutation } from "../../../../store/api/gateEntryApiNew.jsx";
import {
  useGetGenderOptionsQuery,
  useGetUserOptionsQuery,
  useGetSalutationOptionsQuery,
  useGetDocTypeOptionsQuery,
  useCreateContactMutation,
} from "../../../../store/api/contactapi.jsx";
import { useNavigate } from "react-router-dom";
import { usePageState } from "../../../../Hook/usePageState.jsx";
import Tab1 from "./Tab1" ;
function AddVoucher() {
  const [createContact, { isLoadingsix, errorsix, data }] =
    useCreateContactMutation();
  const navigate = useNavigate();

  const [tab, settab] = useState(1);
  const [res, setRes] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);
  const [selected_item_data, setselected_item_data] = useState([]);
  const [selected_item_data_two, setselected_item_data_two] = useState([]);
  const [selected_item_data_three, setselected_item_data_three] = useState([]);
  const [getitem_list_data] = useGetPurchaseOrderListMutation();
  const [invoiceList, setInvoiceList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [CompanyList, setCompanyList] = useState([]);
  const [CostCenterList, setCostCenterList] = useState([]);
  // ---- STATIC DATA ----
  const staticCompany = [
    { id: 1, name: "Stackerbee" },
    { id: 2, name: "Google" },
    { id: 3, name: "Microsoft" },
  ];

  const staticInvoiceType = [
    { id: 1, name: "Regular" },
    { id: 2, name: "Proforma" },
    { id: 3, name: "International" },
  ];
  const staticCostCenter = [
    { id: 1, name: "Regular" },
    { id: 2, name: "Proforma" },
    { id: 3, name: "International" },
  ];
  const staticItemList = [
    {
      Party: "Google Pvt Ltd",
      PostingDate: "2025-01-10",
      DueDate: "2025-01-20",
      ItemName: "Cloud Subscription",
      OutstandingAmount: "12000",
    },
    {
      Party: "Microsoft India",
      PostingDate: "2025-02-05",
      DueDate: "2025-02-15",
      ItemName: "Azure Credits",
      OutstandingAmount: "18000",
    },
    {
      Party: "Stackerbee",
      PostingDate: "2025-03-01",
      DueDate: "2025-03-10",
      ItemName: "MR Project",
      OutstandingAmount: "25000",
    },
  ];

  // ---- SET STATIC DATA ----
  useEffect(() => {
    setCompanyList(staticCompany);
    setInvoiceList(staticInvoiceType);
    setCostCenterList(staticCostCenter);
  }, [staticCompany, staticInvoiceType]);

  const [formData, setFormData] = useState({
    solution: "",
    firstname: "",
    lastname: "",
    gender: "",
    userid: "",
    address: "",
    designation: "",
    company_name: "",
    status: "",
    is_google: false,
    unsubscribed: false,
    department: "",
    is_primary_contact: false,
    is_billing_contact: false,
  });

  const pageStateDefault = {
    tab: 1,
    Company: "",
    InvoiceType: "",
    CreateMissingParty: false,
    CostCenter: "",
  };
  const [pageState, setPageState] = usePageState(
    `Create Opening Invoice Creation Tool`,
    pageStateDefault
  );

  const handleInputChange1 = (f, v) => {
    setPageState({ ...pageState, [f]: v });
  };
  const validateForm = () => {
    const newErrors = {};

    // Tab1 validations
    if (!pageState.Company) newErrors.Check = "Are you want to submit";
    if (!pageState.Company) newErrors.Company = "Company is required";
    if (!pageState.InvoiceType)
      newErrors.InvoiceType = "InvoiceType is required";
    if (!pageState.CreateMissingParty)
      newErrors.lastname = "CreateMissingParty is required";
    if (!pageState.CostCenter) newErrors.gender = "CostCenter is required";

    setErrors(newErrors);

    // return false if errors exist
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      // show first error in alert
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorMsg = errors[firstErrorKey];
      setError(firstErrorMsg || "");
      setptype("Error");
      setShowError(true);
      return;
    }

   

  
  };

  return (
    <>
      <FormLayoutTwo
        title="New Period Closing Voucher"
        breadcrumbs={[
          { label: "Master" },
          {
            label: "New Period Closing Voucher ",
            url: "Period-Closing-Voucher-List/NewPeriodClosingVoucher",
          },
        ]}
        status={res ? "Draft" : "New"}
        actionButtons={
          <>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: "2px", height: "28px" }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: "21px" }}
            />
          </>
        }
      >
        <div
          className=""
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul
                className="nav nav-tabs"
                style={{ color: "white", border: "none" }}
              >
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a
                    className={
                      tab === 1
                        ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                        : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                    }
                    onClick={() => settab(1)}
                    href="javascript:void(0);"
                  >
                    General Details{" "}
                    {tab === 1 ? (
                      <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                    ) : (
                      <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                    )}
                  </a>
                </li>
              </ul>
              <div
                className="d-flex align-items-center mb-2 px-3"
                style={{ gap: "2px", fontSize: "12px" }}
              >
                <span style={{ position: "relative", top: "-1px" }}>
                  <GetIcon
                    className="text-[#4B002B]"
                    iconName="CgAttachment"
                    size={12}
                  />
                </span>
                <span className="fw-semibold" style={{ color: "#4B002B" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>

          <div className=" " style={{ background: "" }}>
            <div className="row">
              <div className="col-12">
                <div className="sidebarbox m-0">
                  <Tab1
                    CompanyList={CompanyList}
                    invoiceList={invoiceList}
                    userList={userList}
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    errors={errors}
                    CostCenterList={CostCenterList}
                    list_data={staticItemList}
                    setselected_item_data={setselected_item_data}
                    onInputChange={(f, v) =>
                      setPageState({ ...pageState, [f]: v })
                    }
                  />
                </div>

                {/* <div className="sidebarbox m-0">
                                    <Tab2
                                        errors={errors}


                                        formData={formData}
                                        onInputChange={handleInputChange}
                                    />
                                </div> */}
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  );
}

export default AddVoucher;
